import initialState from './initialState';

import {
  FETCH_CONFIGURATION_SETTINGS_PILL,
  FETCH_CONFIGURATION_SETTINGS_PILL_SUCCESS,
  FETCH_CONFIGURATION_SETTINGS_PILL_FAILURE,
  FETCH_CONFIGURATION_SETTINGS_FOR_EXPORT,
  FETCH_CONFIGURATION_SETTINGS_FOR_EXPORT_FAILURE,
} from './types';

import { LOGOUT_SUCCESS } from '../../../userData/store/types';

import { Resources } from '../constants';

const getResourceKey = pillType => Resources[pillType];

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOGOUT_SUCCESS:
      return {
        ...initialState,
      };

    case FETCH_CONFIGURATION_SETTINGS_PILL:
      return {
        ...state,
        loading: {
          ...state.loading,
          [getResourceKey(action.pillType)]: true,
        },
      };

    case FETCH_CONFIGURATION_SETTINGS_PILL_SUCCESS: {
      const key = getResourceKey(action.pillType);
      return {
        ...state,
        [key]: action[key],
        loading: {
          ...state.loading,
          [key]: false,
        },
      };
    }

    case FETCH_CONFIGURATION_SETTINGS_PILL_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          [getResourceKey(action.pillType)]: false,
        },
      };

    case FETCH_CONFIGURATION_SETTINGS_FOR_EXPORT:
    case FETCH_CONFIGURATION_SETTINGS_FOR_EXPORT_FAILURE:
      return {
        ...state,
        loading: action.loading,
      };

    default:
      return state;
  }
}
